import React, { Component } from 'react';
import { connect } from "react-redux";
import {FreeConstants} from "../../components-basic/customRoute/Endpoints/Endpoint/FreeConstants";

const ClassicCustomParametersNotice = ({ premium }) => {
	return (
		<React.Fragment>
		{ !premium ?
      <div className="notice notice-info inline" style={{opacity: 1, display: 'block'}}>
        <p>Through the basic version you are limited to add only {FreeConstants.parameters} URL custom parameter. Get Pro to add unlimited URL custom parameters.</p>
      </div> : ''
    }
		</React.Fragment>
	)
};

export default connect( state => ({
	premium: state.premium
}))(ClassicCustomParametersNotice);
